import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import NorthableDialog from '../json-pages/NorthableDialog';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/primary`} component={NorthableDialog} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
